import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'

import { AuthProvider, useAuth } from './context/AuthContext'
import Layout from './components/Layout'
import ProtectedRoute from './components/ProtectedRoute'

import Login from './pages/Login'
import VerifyCode from './pages/VerifyCode'
import Dashboard from './pages/Dashboard'
import RegisterUser from './pages/RegisterUser'
import AdminUsuarios from './pages/AdminUsuarios'
import Anticipos from './pages/Anticipos'

const AuthRedirect = () => {
  const { isAuthenticated, isCodeSent } = useAuth()
  if (isAuthenticated) return <Navigate to="/dashboard" replace />
  if (isCodeSent) return <Navigate to="/verify" replace />
  return <Navigate to="/login" replace />
}

const WithLayout = () => (
  <Layout>
    <Outlet />
  </Layout>
)

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<RegisterUser />} />

          <Route element={<WithLayout />}>
            <Route path="/" element={<AuthRedirect />} />
            <Route path="/verify" element={<VerifyCode />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/anticipos"
              element={
                <ProtectedRoute>
                  <Anticipos />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/usuariosweb"
              element={
                <ProtectedRoute adminRequired={true}>
                  <AdminUsuarios />
                </ProtectedRoute>
              }
            />

            <Route
              path="*"
              element={
                <div className="section">
                  <div className="container has-text-centered">
                    <div className="box">
                      <h1 className="title is-4 mt-4">Página no encontrada</h1>
                      <p className="subtitle is-6">
                        La página que busca no existe o ha sido movida.
                      </p>
                      <div className="buttons is-centered">
                        <button
                          className="button is-primary"
                          onClick={() => (window.location.href = '/')}
                        >
                          Ir al inicio
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              }
            />
          </Route>
        </Routes>

        <Toaster
          position="top-right"
          toastOptions={{
            duration: 5000,
            style: { background: '#363636', color: '#fff', fontSize: '14px' },
            success: { iconTheme: { primary: '#48c774', secondary: '#fff' } },
            error: { iconTheme: { primary: '#f14668', secondary: '#fff' } },
          }}
        />
      </Router>
    </AuthProvider>
  )
}

export default App
